<template>
  <div :class="$style.container">
    <payment-template>
      <project-header
        slot="header"
        :project="PROJECT"
        :language="getLanguage"
      />
      <access-denied
        slot="content"
        :title="displayTitle"
        :message="$t('bill.blocked.message', { email: getDisplayMerchantEmail })"
      />
      <base-footer
        slot="footer"
        security
      />
    </payment-template>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import BaseFooter from 'molecules/base/BaseFooter';
import AccessDenied from 'molecules/common/AccessDenied';
import ProjectHeader from 'organisms/project/ProjectHeader';
import PaymentTemplate from 'templates/PaymentTemplate';

export default {
  name: 'BillBlocked',
  components: {
    BaseFooter,
    AccessDenied,
    ProjectHeader,
    PaymentTemplate,
  },
  computed: {
    displayTitle() {
      const projectCurrency = this.PROJECT.currency;
      const billCurrency = this.PROJECT.billTariffs[0].currency;

      const isCurrencyMismatch = projectCurrency.code !== billCurrency.code;

      if (isCurrencyMismatch) {
        return this.$t('bill.blocked.currency.mismatch');
      }

      return this.$t('bill.blocked.title');
    },
    ...mapState(['PROJECT']),
    ...mapGetters([
      'getLanguage',
      'getDisplayMerchantEmail',
    ]),
  },
};
</script>

<style lang="sass" module>
  .container
    +error-overlay
</style>
